import React, { useState, useEffect, useRef } from "react";
import { Link, Outlet, Route } from "react-router-dom";
import { MenuKiri } from "../../helper/functionMenu";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment/moment";
// import { sampleMenu } from "../../sampleMenu";
import { deleteAllCookies, ReadableTime } from "../../helper/function";
import { fetchApi } from "../../helper/api";
import ChangePassword from "../molecules/popup/ChangePassword";
import "./scale.css";
import { MQTTI } from "../../helper/mqttClient";
import { useSnackbar } from "notistack";

const Layout = (props) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  const [notification, setNotification] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  let listInnerRef = useRef();

  useEffect(() => {
    MenuKiri.initBeforeLoad();
    MenuKiri.initCore();
    const instance = MQTTI().subscribe(
      `JembatankuMaster/notification/${props._dataProfile.email}`
    );
    instance.on("message", (topic, message) => {
      // const payload = { topic, message: message.toString() };
      const metaNotification = JSON.parse(message.toString());
      // console.log("Payload", JSON.parse(message.toString()));
      const timestamp = Date.now();
      enqueueSnackbar(metaNotification.body, {
        key: timestamp,
        persist: false,
        variant: switchVariant(metaNotification.dataPayload.status),
        onClick: () => {
          // navigate(metaNotification.dataPayload.linkSensor);
          closeSnackbar(timestamp);
        },
      });
    });
    return () => {
      instance.end();
    };
  }, []);

  useEffect(() => {
    setNotification([]);
    getNotification();
  }, [location.pathname]);

  useEffect(() => {
    if (page > 1) {
      // console.log("masuk sini", page);
      setLoading(true);
      getNotification();
    }
  }, [page]);

  const getNotification = async () => {
    const req = await fetchApi(
      `api/Notification/unread?page=${page}`,
      "GET",
      true
    );
    const status = req.status;
    if (status === 200) {
      const res = await req.json();
      const { data } = res;
      const notifAll = data.notifsUnread;
      // console.log("notifall", notifAll);
      if (notification.length !== 0) {
        setNotification((current) => {
          return [...current, ...notifAll];
        });
      } else {
        setNotification(notifAll);
      }
    } else {
      alert("Gagal mendapatkan notifikasi!");
    }
    setLoading(false);
  };

  const clearNotification = async () => {
    const req = await fetchApi("api/Notification/readAll", "GET", true);
    const status = req.status;
    if (status === 200) {
      setNotification([]);
      getNotification();
    }
  };

  const getUsername = () => {
    const split = props._dataProfile.email.split("@");
    return split[0];
  };

  const handleLogout = () => {
    deleteAllCookies();
    navigate("/login");
  };

  const showMenu = () => {
    return props._sidebar.map((e, i) => {
      if (e.submenu.length > 0) {
        return (
          <li className="nav-item nav-item-submenu" key={i}>
            <span className="nav-link" title={e.name}>
              <i className={e.icon} style={{ fontSize: 28 }}></i>
              <span>{e.name}</span>
            </span>
            <ul className="nav nav-group-sub" data-submenu-title={e.name}>
              {e.submenu.map((s, n) => {
                return (
                  <li className="nav-item" key={n}>
                    <Link to={s.path} className="nav-link" title={s.name}>
                      <i className="icon-circle-small mr-1 text-pink"></i>
                      {s.name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </li>
        );
      } else {
        return (
          <li className="nav-item" key={i}>
            <Link to={e.path} className="nav-link" title={e.name}>
              <i className={e.icon} style={{ fontSize: 28 }}></i>
              <span>{e.name}</span>
            </Link>
          </li>
        );
      }
    });
  };

  // const jumlahNotif = () => {
  //   const cek = notification.filter((e) => e.readAt === 0);
  //   const jumlah = cek.length;
  //   return jumlah;
  // };

  const readNotif = async (id, link) => {
    const req = await fetchApi(`api/Notification/read/${id}`, "GET", true);
    const status = req.status;
    if (status === 200) {
      if (link) {
        // console.log("clicked navigate to: ", link);
        navigate(link);
      }
    }
  };

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      const total = Number(scrollTop.toFixed(0)) + Number(clientHeight);
      const bottomHeight = Number(scrollHeight) - 10;
      // console.log("scrollHeight: ", scrollHeight);
      // console.log("scrollTop: ", scrollTop.toFixed(0));
      // console.log("clientHeight", clientHeight);
      console.log("TOTAL", total);
      console.log("BOTTOM HEighT", bottomHeight);
      // console.log("PAGE", page);
      if (total >= bottomHeight && !loading) {
        // console.log("BOTTOM REACHED");
        setPage((current) => current + 1);
      }
    }
  };

  const switchVariant = (status) => {
    switch (status) {
      case "2":
        return "error";
      case "1":
        return "warning";
      default:
        return "default";
    }
  };

  // console.log("NOTIFICATION", notification);

  return (
    <>
      <ChangePassword />
      <div className="navbar navbar-expand-md navbar-dark fixed-top">
        <div className="d-md-none">
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbar-mobile"
          >
            <i className="icon-tree5" />
          </button>
          <button
            className="navbar-toggler sidebar-mobile-main-toggle"
            type="button"
          >
            <i className="icon-paragraph-justify3" />
          </button>
        </div>
        <div className="collapse navbar-collapse pl-md-0" id="navbar-mobile">
          <div className="d-flex">
            <ul className="navbar-nav">
              <li className="nav-item">
                <span className="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block">
                  <i className="icon-paragraph-justify3" />
                </span>
              </li>
            </ul>
            <div className="d-flex align-items-center">
              <h4 className="mb-0">JEMBATAN KHUSUS SUMSEL (SHMS)</h4>
            </div>
          </div>
          <ul className="navbar-nav ml-auto">
            <li className="nav-item dropdown">
              <span
                className="navbar-nav-link dropdown-toggle caret-0"
                data-toggle="dropdown"
              >
                <i className="icon-bell2" />
                {/* <span className="d-md-none ml-2">Notifications</span> */}
                {/* {notification && jumlahNotif() > 0 && (
                  <span className="badge badge-pill bg-danger mt-1">
                    {notification && jumlahNotif()}
                  </span>
                )} */}
                {notification.length > 0 && (
                  <span
                    className="badge badge-pill bg-danger"
                    style={{
                      margin: "15px 10px 0px 0px",
                      width: "14px",
                      height: "12px",
                    }}
                  >
                    {" "}
                  </span>
                )}
              </span>
              <div className="dropdown-menu dropdown-menu-right dropdown-content wmin-md-350">
                <div className="dropdown-content-header">
                  <span className="font-size-sm line-height-sm text-uppercase font-weight-semibold">
                    Notifikasi Terakhir
                  </span>
                  {/* <a href="#" className="text-default">
                    <i className="icon-search4 font-size-base" />
                  </a> */}
                </div>
                <div
                  className="dropdown-content-body dropdown-scrollable"
                  onScroll={onScroll}
                  ref={listInnerRef}
                >
                  <ul className="media-list">
                    {notification.length > 0 ? (
                      notification.map((e, i) => {
                        return (
                          <li
                            key={i}
                            className="mb-2 scale"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              // console.log(e);
                              readNotif(e?._id, e.data?.linkSensor);
                            }}
                          >
                            <span
                              className={`media border shadow py-2 px-1 rounded-banget ${
                                e?.readAt ? "" : "bg-light"
                              }`}
                              style={{ marginBottom: "20px" }}
                            >
                              <div className="mr-3">
                                <div className="btn bg-warning rounded-round btn-icon">
                                  <i className="las la-exclamation"></i>
                                </div>
                              </div>
                              <div className="media-body">
                                <p
                                  style={{
                                    margin: "0px 0px 5px 0px",
                                    padding: "0px",
                                    fontSize: "16px",
                                  }}
                                >
                                  {e.data?.title}
                                </p>
                                <p
                                  style={{
                                    margin: "0px",
                                    padding: "0px",
                                    fontSize: "13px",
                                  }}
                                >
                                  {e.data?.body}
                                </p>
                                <div className="font-size-sm text-muted mt-1">
                                  {ReadableTime(e?.createdAt)}
                                  {/* 2 hours ago */}
                                </div>
                              </div>
                            </span>
                          </li>
                        );
                      })
                    ) : (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <span className="text-center">
                          Tidak ada notifikasi.{" "}
                        </span>
                      </div>
                    )}
                  </ul>
                </div>
                <div className="dropdown-content-footer bg-light">
                  {/* <a
                    href="#"
                    className="font-size-sm line-height-sm text-uppercase font-weight-semibold text-grey mr-auto"
                  >
                    All Notification
                  </a> */}
                  <div>
                    <span
                      className="text-grey"
                      data-popup="tooltip"
                      // title="Tandai semua sudah dibaca"
                      onClick={(event) => {
                        event.preventDefault();
                        if (notification.length !== 0) {
                          clearNotification();
                        }
                      }}
                    >
                      <span
                        className="rounded-round btn"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "20px",
                          margin: "0px",
                          backgroundColor: "white",
                        }}
                      >
                        <i className="icon-checkmark3" />
                        <p
                          style={{
                            margin: "0px",
                            padding: "0px",
                          }}
                        >
                          Tandai semua telah dibaca
                        </p>
                      </span>
                    </span>
                    {/* <a
                      href="#"
                      className="text-grey ml-2"
                      data-popup="tooltip"
                      title="Settings"
                    >
                      <i className="icon-gear" />
                    </a> */}
                  </div>
                </div>
              </div>
            </li>
            <li className="nav-item dropdown dropdown-user">
              <span
                className="navbar-nav-link d-flex align-items-center dropdown-toggle py-1 h-100"
                data-toggle="dropdown"
              >
                <div className="d-flex flex-column">
                  <h6 className="mb-0">{getUsername()}</h6>
                  <p className="mb-0">
                    <i>{props._dataProfile?.role}</i>
                  </p>
                </div>
                {/* <span className='rounded-banget bg-success px-2 py-1 f-11 ml-1'>Healty</span> */}
              </span>
              <div className="dropdown-menu dropdown-menu-right">
                <div className="dropdown-item mt-2" style={{ cursor: "none" }}>
                  <i className="las la-user" style={{ fontSize: 22 }}></i>{" "}
                  {props._dataProfile.email}
                </div>
                <div className="dropdown-divider"></div>
                <span
                  className="dropdown-item"
                  data-toggle="modal"
                  data-target="#exampleModal"
                >
                  <i className="las la-user-lock" style={{ fontSize: 22 }}></i>{" "}
                  Change Password
                </span>
                <span
                  className="dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                  <i className="las la-sign-out-alt" style={{ fontSize: 22 }} />
                  Logout
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="page-content">
        <div className="sidebar sidebar-light sidebar-main sidebar-expand-md sidebar-fixed">
          {/* Sidebar mobile toggler */}
          <div className="sidebar-mobile-toggler text-center">
            <span className="sidebar-mobile-main-toggle">
              <i className="icon-arrow-left8" />
            </span>
            Navigation
            <span className="sidebar-mobile-expand">
              <i className="icon-screen-full" />
              <i className="icon-screen-normal" />
            </span>
          </div>
          {/* /sidebar mobile toggler */}
          {/* Sidebar content */}
          <div className="sidebar-content bg-white shadow">
            {/* Main navigation */}
            <div className="card card-sidebar-mobile h-100">
              <ul className="nav nav-sidebar mt-2" data-nav-type="accordion">
                {showMenu()}
              </ul>
              {/* <ul
                className="nav nav-sidebar menu-bawah"
                data-nav-type="accordion"
              >
                `
                <li className="nav-item">
                  <a href="#" className="nav-link" title="Change Password">
                    <i
                      className="las la-user-lock"
                      style={{ fontSize: 28 }}
                    ></i>
                    <span>Change Password</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#" className="nav-link" title="Sign Out">
                    <i
                      className="las la-sign-out-alt"
                      style={{ fontSize: 28 }}
                    ></i>
                    <span>Sign Out</span>
                  </a>
                </li>
              </ul>
              ` */}
            </div>
            {/* /main navigation */}
          </div>
          {/* /sidebar content */}
        </div>
        <div className="content-wrapper py-4 px-md-5 px-1">
          <Outlet />
        </div>
      </div>
    </>
  );
};
const mapState = (state) => {
  return {
    _sidebar: state.sidebar,
    _dataProfile: state.dataProfile,
  };
};

const actionCreators = (dispatch) => {
  return {
    _addProfile: (data) => dispatch({ type: "ADD_PROFILE", payload: data }),
    _addSidebar: (data) => dispatch({ type: "ADD_SIDEBAR", payload: data }),
  };
};
export default connect(mapState, actionCreators)(Layout);
